export const pTON_OP_CODES = {
  DEPLOY_WALLET: 0x6cc43573,
} as const;
